import React, { FC } from 'react'

import { CheckmarkIcon, IconSizes, IconWeight } from '@inno-ui/icons'
import { Trans, useTranslation } from 'react-i18next'

import styles from './PostOnboardingScreen.module.scss'
import { PostOnboardingScreenProps } from './PostOnboardingScreen.types'

export const PostOnboardingScreen: FC<PostOnboardingScreenProps> = ({
  onClose
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.post_onboarding_screen'
  })

  return (
    <div className={styles.postOnboardingScreen}>
      <div className={styles.content}>
        <h2 className={styles.subTitle}>{t('sub_title')}</h2>
        <div className={styles.texts}>
          <h1 className={styles.title}>
            <Trans
              t={t}
              i18nKey={'title'}
              components={{
                highlighted: <span className={styles.highlighted} />
              }}
            />
          </h1>
          <p className={styles.description}>{t('description')}</p>
        </div>
      </div>
      <button onClick={onClose} className={styles.readyButton}>
        <span className={styles.label}>{t('ready_button')}</span>
        <CheckmarkIcon
          color='var(--primary-blue-light)'
          weight={IconWeight.Bold}
          size={IconSizes.Size18}
        />
      </button>
    </div>
  )
}
